import React, { useState, useEffect } from 'react';
import {  withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@mui/styles';
import {
  Grid,
  Button,
  IconButton,
  TextField,
  
  Typography
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


import { Alert, AlertTitle } from '@mui/material';

import API from 'util/API';
import analytics from "common/analytics";

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.white,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 80,
    paddingRight: 80,
    paddingBottom: 125,
    flexBasis: 800,
    maxWidth: '800px',
    width: '100%',
    minWidth: '500px',
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      minWidth: '400px'
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minWidth: '320px'
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    width: '100% !important',
    minWidth: '400px',
    '& .MuiOutlinedInput-root': {
      minHeight: '56px !important',
      width: '100% !important',
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      }
    },
    '& .MuiInputLabel-root': {
      fontSize: '1rem',
    },
    '& .MuiOutlinedInput-input': {
      padding: '16.5px 14px !important',
      fontSize: '1rem',
      width: '100% !important',
      boxSizing: 'border-box'
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '280px'
    }
  },
  signInButton: {
    margin: theme.spacing(2.5, 0)
  }
}));


const SignIn = props => {
  const { history } = props;

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleBack = () => {
    history.goBack();
  };

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };
  const [loading, setLoading] = useState(false)
  const [loginError, setLoginError] = useState(false)

  const handleSignIn = event => {
    event.preventDefault();
    setLoading(true);
    const userData = {
      email: formState.values.email,
      password: formState.values.password
    };

    analytics.track("signIn", {
      email: formState.values.email,
    });

    //console.log('import.meta.env.VITE_APP_API_URL', import.meta.env.VITE_APP_API_URL);
   
    API
      .post('/login', userData,{withCredentials: true})
      .then(() => {
        setLoading(false);
        history.push('/dashboard');
      })
      .catch((error) => {
        console.log('error', error);
        setLoading(false);
        setLoginError(true);
      });

  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
      >

        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentHeader}>
              <IconButton onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
            </div>
            <div className={classes.contentBody}>
              <form
                className={classes.form}
                onSubmit={handleSignIn}
              >
                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Sign in
                </Typography>

                <Typography
                  align="center"
                  className={classes.sugestion}
                  color="textSecondary"
                  variant="body1"
                >
                  login with email address
                </Typography>
                <TextField
                  className={classes.textField}
                  error={hasError('email')}
                  fullWidth
                  helperText={
                    hasError('email') ? formState.errors.email[0] : null
                  }
                  label="Email address"
                  name="email"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.email || ''}
                  variant="outlined"
                />
                <TextField
                  className={classes.textField}
                  error={hasError('password')}
                  fullWidth
                  helperText={
                    hasError('password') ? formState.errors.password[0] : null
                  }
                  label="Password"
                  name="password"
                  onChange={handleChange}
                  type="password"
                  value={formState.values.password || ''}
                  variant="outlined"
                />
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                  
                <Button
                  className={classes.signInButton}
                  color="primary"
                  disabled={!formState.isValid || loading}
                fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Sign in now
                </Button>
                </Grid>
                <Grid item xs={4}>
                  
                <NavLink to="/forget-password" className={classes.textLink}>
                <Button
                  className={classes.signInButton}
                  fullWidth
                  color="warning"
                  size="small"
            
                  
                >
                 Forget Password
                </Button>
                </NavLink>
                </Grid>
                </Grid>
                {loginError ?
                <Alert severity="error">
                  <AlertTitle>Error</AlertTitle>
  This is a login error!
</Alert>
                : null}
              </form>
   
            </div>
          </div>
        </Grid>

      </Grid>
    </div>
  );
};

SignIn.propTypes = {
  history: PropTypes.object
};

export default withRouter(SignIn);
